import intlTelInput from 'intl-tel-input/build/js/intlTelInputWithUtils';

// import 'intl-tel-input/build/css/intlTelInput.css';

// function autofillCountryPhoneNumber(now, callback) {
//   // try using api unless Quota exceeded
//   // then use local backup
//   fetch('https://ipapi.co/json')
//     .then((res) => res.json())
//     .then((data) => {
//       const countryCode = data.country_code;
//       localStorage.setItem(KEY_FORM_COUNTRY_CODE, countryCode);
//       localStorage.setItem(KEY_LAST_COUNTRY_CODE_CHECK, now);
//       callback(data.country_code);
//     })
//     .catch(() => {
//       console.log('js: fetch error');
//       console.log('js: trying local ajax');
//       // use local backup
//       $.ajax({
//         method: 'POST',
//         url: '',
//         data,
//         dataType: 'json',
//       })
//         .done((data) => {
//           let countryCode;
//           if (data.result === true) {
//             countryCode = data.countryCode;
//             localStorage.setItem(KEY_FORM_COUNTRY_CODE, countryCode);
//             localStorage.setItem(KEY_LAST_COUNTRY_CODE_CHECK, now);
//             console.log('js: Country Code');
//             console.log(data.countryCode);
//           } else {
//             console.log('js: Ajax/Error could not set Country Code');
//             countryCode = false;
//           }

//           callback(countryCode);
//         })
//         .fail((data) => {
//           console.log('js: Ajax/Error error getting Country Code');
//           callback(countryCode);
//         });
//     });
// }

function setupContactFormPhoneValidationElement(phoneInputElement) {
  const phoneNumberElement = document.querySelector('.js-contact-form__phone-number');
  let iti;

  if (phoneNumberElement) {
    console.log(window.sortedCountryCodeTranslations);
    console.log(window.sortedCountryCodes);
    iti = intlTelInput(phoneInputElement, {
      // nationalMode: true,
      // preferredCountries: [
      //   'af','al','ag','ar','at','au','bf','bh','bg','bb','be','bz','bn','bl','ba','bc','br','bu','uv','bm','cb','ca','xx','cd','ci','ch','co','cs','cv','hr','ez','da',
      //   'dr','ec','eg','es','en','et','fi','fr','gm','gh','gr','gt','ha','ho','hk','hu','in','id','ir','iz','ei','il','it','iv','jm','ja','jo','kz','ke','ks','ku','la',
      //   'lg','lt','li','lh','mk','ma','mi','my','ml','mp','mx','me','mo','mz','wa','np','nl','nz','nu','ng','ni','no','om','pk','pm','pa','pe','rp','pl','po','qa','cd',
      //   're','ro','rs','rw','sm','sa','sq','rs','sn','lo','si','sf','sp','lk','su','wz','sw','sz','sy','tw','ti','tz','th','to','td','ts','tu','tx','ug','up','ae','uk',
      //   'us','uz','ve','vm','ye','yu','za','zi',
      // ],
      preferredCountries: [],
      localizedCountries: window.sortedPhoneCountryCodeTranslations,
      onlyCountries: window.sortedPhoneCountryCodes,
      // autoPlaceholder: 'aggressive',
      initialCountry: 'us',
      // initialCountry: 'auto',
      separateDialCode: true,
      showFlags: false,
      // geoIpLookup: function(callback) {
      //   if (disableGeoIpLookup === true){
      //     callback('af');
      //     return;
      //   }

      //   // to prevent the site from check every page load, we use local storage to cache
      //   const lSCountryCode = localStorage.getItem(KEY_FORM_COUNTRY_CODE);
      //   const lSLastCountryCodeCheck = localStorage.getItem(KEY_LAST_COUNTRY_CODE_CHECK);

      //   // check if country code and time are valid
      //   if (
      //     lSCountryCode !== null
      //     && lSCountryCode.length > 0 && lSCountryCode.length <= 3
      //     && (
      //       lSLastCountryCodeCheck !== null
      //       && now - lSLastCountryCodeCheck < ONE_HOUR // check if time has expired
      //     )
      //   ) {
      //     callback(lSCountryCode);
      //   } else {
      //     // check which policy it should load
      //     const data = {
      //       action: 'Ip2Country/getCountryCode',
      //     };

      //     // try using api unless Quota exceeded
      //     autofillCountryPhoneNumber(now, callback);
      //   }
      // },

      // loadUtilsOnInit: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js',
      // utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js',

      // loadUtilsOnInit: () => import('intl-tel-input/build/js/utils'),
    });
  }

  return iti;
}

export default setupContactFormPhoneValidationElement;
